import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import { DocumentModel, DocumentServiceFactory } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import { LoggerFactory } from "@com.mgmtp.a12.utils/utils-logging";

const logger = LoggerFactory.getLogger("getDocumentModelElement");

export function getDocumentModelElement(
	documentModel: DocumentModel,
	path: ModelPath
): DocumentModel.Element | undefined {
	const documentModelElement = new DocumentServiceFactory()
		.getDocumentModelSearchService(documentModel)
		.getByPath(path);

	if (!documentModelElement) {
		logger.error(`No element found for path ${path} in model ${documentModel.header.id}!`);
		return undefined;
	}

	return documentModelElement;
}
